import { useCallback, useState } from 'react'

import { mergePendingChatAttachments } from 'utils/chatAttachmentLimits'
import { alertDanger } from 'utils/toast'

export function usePendingChatAttachments() {
  const [files, setFiles] = useState<File[]>([])

  const addFiles = useCallback((incoming: FileList | File[]) => {
    const list = Array.from(incoming)
    if (list.length === 0) return

    setFiles((current) => {
      const { next, rejected } = mergePendingChatAttachments(current, list)
      for (const item of rejected) {
        alertDanger(`${item.name}: ${item.reason}`)
      }
      return next
    })
  }, [])

  const removeAt = useCallback((index: number) => {
    setFiles((current) => current.filter((_, i) => i !== index))
  }, [])

  const clear = useCallback(() => {
    setFiles([])
  }, [])

  return {
    files,
    count: files.length,
    addFiles,
    removeAt,
    clear,
    hasFiles: files.length > 0,
  }
}
